import classNames from 'classnames'
import { forwardRef, HTMLAttributes } from 'react'

import { Slot } from '../utilities'
import styles from './snippet-body.module.scss'

export type SnippetBodyElement = HTMLDivElement

export type SnippetBodyProps = HTMLAttributes<SnippetBodyElement> & {
  asChild?: boolean
}

const SnippetBody = forwardRef<SnippetBodyElement, SnippetBodyProps>(function SnippetBody(
  props,
  forwardedRef
) {
  const { children, className, asChild, ...rest } = props

  const classes = classNames(styles.root, className)

  const Component = asChild ? Slot : 'div'

  return (
    <Component {...rest} className={classes} ref={forwardedRef}>
      {children}
    </Component>
  )
})

export default SnippetBody
